import React from 'react';
import { ADMITTED_ELSEWHERE_COPY } from '../../constants/admission';

/**
 * Informational chip on a patient-lookup result row (Register Visit, Admit
 * Patient, Book Appointment). Shown only when the server says the patient has
 * a live admission this caller cannot see (`admitted_other_department === true`
 * on a GET /patients?mobile= item). Deliberately no link, no IP number and no
 * department name — the server does not send them. The row stays selectable.
 * Absent / false (old backend, unwalled caller) renders nothing.
 */
export default function AdmittedElsewhereLabel({ patient }) {
  if (patient?.admitted_other_department !== true) return null;
  return (
    <span
      data-testid="admitted-elsewhere-label"
      className="inline-block mt-1 px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-100"
    >
      {ADMITTED_ELSEWHERE_COPY}
    </span>
  );
}
